export default __webpack_public_path__ + "static/media/050-orange juice.64b8f3d6.svg";